import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import FileUploader from '../FileUploader'
import { t } from '../../utils/i18n'
import { getTranslation } from '../../utils/bike-schema'
import LogoInfo from '../LogoInfo'
import { logoUploaded, logoRemove } from '../../actions'
import { BikeAngle, Component, LanguageCode } from 'shared'

interface LogoPopoverItemProps {
  item: {
    component: Component | undefined
    logoUrl?: string
    angle: BikeAngle
  }
  lang: LanguageCode
}

const LogoPopoverItem: React.FC<LogoPopoverItemProps> = ({ item, lang }) => {
  const { component, logoUrl, angle } = item
  const dispatch = useDispatch()

  const [visible, setVisible] = useState<boolean>(false)
  const [textVisible, setTextVisible] = useState<boolean>(false)

  const handleTextClick = (color: 'white' | 'black') => {
    handleUpload(
      color === 'white'
        ? 'https://velorbis2.s3.amazonaws.com/uploads/be2fdd49-3672-4247-adb3-762dc5bc938d/white.png'
        : 'https://velorbis2.s3.amazonaws.com/uploads/8f6f7d46-38a7-4e5f-bb69-f400a44014fc/black.png'
    )
  }

  const handleUpload = (url: string) => {
    fetch(url)
      .then(() => {
        dispatch(logoUploaded(component?.id, url, angle))
      })
      .catch(() => {
        setTimeout(
          () => dispatch(logoUploaded(component?.id, url, angle)),
          2000
        )
      })
  }

  let label = ''
  if (angle !== 'none') {
    label = t(`${component?.id}_${angle}`)
  } else label = component ? getTranslation(component.name) : ''

  if (logoUrl) {
    return (
      <div className="velorbis-customizer-form-control velorbis-customizer-popover-body-logo-item">
        <div className="velorbis-customizer-popover-body-logo-item-div">
          <label>{label}</label>
          <div
            className="tooltip tooltip__logo"
            onMouseEnter={() => setVisible(true)}
          >
            &#9432;
          </div>
        </div>
        {visible && (
          <div className="logo-content">
            <div>
              <button
                className="close-button"
                onClick={() => setVisible(false)}
              >
                X
              </button>
              <LogoInfo lang={lang} />
            </div>
          </div>
        )}
        <img
          className="velorbis-customizer-file-preview"
          src={logoUrl}
          alt="file-preview"
        />
        <div className="velorbis-customizer-popover-buttons velorbis-customizer-sm-space-top">
          <button
            className="velorbis-customizer-button velorbis-customizer-button-sm"
            onClick={() => dispatch(logoRemove(component?.id, angle))}
          >
            {t('logo_remove')}
          </button>
        </div>
      </div>
    )
  } else {
    return (
      <div className="velorbis-customizer-form-control velorbis-customizer-popover-body-logo-item">
        <div className="velorbis-customizer-popover-body-logo-item-div">
          <label>{label}</label>
          <div
            className="tooltip tooltip__logo"
            onMouseEnter={() => setVisible(true)}
          >
            &#9432;
          </div>
        </div>
        {visible && (
          <div className="logo-content">
            <div>
              <button
                className="close-button"
                onClick={() => setVisible(false)}
              >
                X
              </button>
              <LogoInfo lang={lang} />
            </div>
          </div>
        )}
        {textVisible && (
          <div className="logo-content">
            <div>
              <button
                className="close-button"
                onClick={() => setTextVisible(false)}
              >
                X
              </button>
              <div className="velorbis-logo-info">{t('text_logo_info')}</div>
            </div>
          </div>
        )}
        <FileUploader uploaded={handleUpload} />
        <div style={{ width: '100%', marginTop: '10px' }}>
          <button
            className="button-override"
            onClick={() => handleTextClick('white')}
          >
            {t('text_logo_button_white')}
          </button>
          <span
            className="tooltip tooltip__logo"
            onMouseEnter={() => setTextVisible(true)}
          >
            &#9432;
          </span>
          <button
            className="button-override"
            onClick={() => handleTextClick('black')}
          >
            {t('text_logo_button_black')}
          </button>
          <span
            className="tooltip tooltip__logo"
            onMouseEnter={() => setTextVisible(true)}
          >
            &#9432;
          </span>
        </div>
      </div>
    )
  }
}

export default LogoPopoverItem
